import React from "react";
import { partners } from "../mock";
import { useLanguage } from "../contexts/LanguageContext";

const Partners = () => {
  const { t } = useLanguage();
  const { prefix, highlight, suffix } = t.partners.titleParts;
  // Duplicate for seamless infinite scroll
  const loop = [...partners, ...partners, ...partners];

  return (
    <section className="mag-partners" id="partners">
      <div className="mag-section-heading">
        <h2 style={{ color: "#ea6161" }}>
          {prefix}
          <span>{highlight}</span>
          {suffix}
        </h2>
        <div className="mag-underline-red" />
      </div>
      <div className="mag-partners-track">
        {loop.map((p, idx) => (
          <div key={`${p.id}-${idx}`} className="mag-partner-logo">
            {p.name}
          </div>
        ))}
      </div>
    </section>
  );
};

export default Partners;
